import React from 'react';
import { TableCell } from '@mui/material';
import _ from 'lodash';
import { getNumberComma } from '../../utils/numberUtils';
import { hqTyps } from '../../utils/eis-statics-data';

const SalesManageStaticsTableCell = ({ headerRows, data }) => {
  if (!headerRows || !data) {
    return null;
  }

  return (
    headerRows &&
    headerRows.map((field, fIndex) => {
      return hqTyps.map((type, tIndex) => {
        const findDt = _.find(data, { id: field.id });
        let key = `${fIndex}_${tIndex}`;
        const value = _.get(findDt, type.id);

        return (
          <TableCell
            sx={{ width: '100px' }}
            align="right"
            padding="none"
            key={key}
          >
            {getNumberComma(value)}
          </TableCell>
        );
      });
    })
  );
};

export default SalesManageStaticsTableCell;
